/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import AssetService from "../../services/AssetService";
import ManufacturerService from "../../services/ManufacturerService";
import ServiceProviderService from "../../services/ServiceProviderService";
import VendorService from "../../services/VendorService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdSelect, AntdTag } from "../../utils/Antd";
import util from "../../utils/util";
import BTabs, { PageHeading } from "./Tabs";
import plus from "../assets/icons/plus-solid.svg"
import edit from "../assets/icons/pen-to-square-solid.svg"
import xmark from "../assets/icons/circle-xmark-solid.svg"
import search from "../assets/icons/magnifying-glass-solid.svg"
import * as XLSX from 'xlsx';
import {
    Input, Button, message, Modal, Tabs, Upload, Table,
    Progress, Alert, Divider, Dropdown, Select, Tag, Tooltip,
} from 'antd';
import {
    ExclamationCircleOutlined, UploadOutlined, DownloadOutlined,
    InboxOutlined, MoreOutlined, CheckCircleOutlined,
    QuestionCircleOutlined, CloseCircleOutlined,
} from '@ant-design/icons';

const { confirm } = Modal;
const { Dragger }  = Upload;
const { Option }   = Select;

// ── Fuzzy match utility ───────────────────────────────────────────────────────
function stringSimilarity(a, b) {
    if (!a || !b) return 0;
    a = a.toLowerCase().trim(); b = b.toLowerCase().trim();
    if (a === b) return 1;
    if (b.includes(a) || a.includes(b)) return 0.85;
    const m = a.length, n = b.length;
    const dp = Array.from({ length: m+1 }, (_, i) =>
        Array.from({ length: n+1 }, (_, j) => (i===0 ? j : j===0 ? i : 0))
    );
    for (let i = 1; i <= m; i++)
        for (let j = 1; j <= n; j++)
            dp[i][j] = a[i-1]===b[j-1] ? dp[i-1][j-1] : 1+Math.min(dp[i-1][j],dp[i][j-1],dp[i-1][j-1]);
    return 1 - dp[m][n] / Math.max(m, n);
}
function findBestMatch(query, list) {
    if (!query || !list?.length) return { id:null, name:null, score:0 };
    let best = { id:null, name:null, score:0 };
    for (const item of list) {
        const score = stringSimilarity(query, item.name);
        if (score > best.score) best = { id:item.id, name:item.name, score };
    }
    return best;
}
function ConfidenceBadge({ score }) {
    if (!score || score===0) return <Tag color="default">No match</Tag>;
    if (score>=0.9)  return <Tag color="success" icon={<CheckCircleOutlined />}>{Math.round(score*100)}%</Tag>;
    if (score>=0.65) return <Tag color="warning" icon={<QuestionCircleOutlined />}>{Math.round(score*100)}%</Tag>;
    return <Tag color="error" icon={<CloseCircleOutlined />}>{Math.round(score*100)}%</Tag>;
}

// ── Items (main export) ───────────────────────────────────────────────────────
export default function Items() {
    const [assetCats,        setAssetCats]        = useState([]);
    const [uoms,             setUoms]             = useState([]);
    const [models,           setModels]           = useState([]);
    const [manufacturers,    setManufacturers]    = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);
    const [vendors,          setVendors]          = useState([]);

    const onTabChange = (key) => { setTab(key); };

    useEffect(() => {
        AssetService.allCats({ status:1 }).then(res => { setAssetCats(res.data.result.data); });
        AssetService.allModel({ status:1 }).then(res => { setModels(res.data.result.data); });
        AssetService.allUom({ status:1 }).then(res => { setUoms(res.data.result.data); });
        ManufacturerService.all({ status:1 }).then(res => { setManufacturers(res.data.result.data); });
        ServiceProviderService.all({ status:1 }).then(res => { setServiceProviders(res.data.result.data); });
        VendorService.all({ status:1 }).then(res => { setVendors(res.data.result.data); });
        return () => { message.destroy(); };
    }, []);

    // ── Superuser bypass ──────────────────────────────────────────────────────
    // Admin / National / Client-Admin have empty app_modules by design.
    // Without this bypass filteredItems = [] and nothing renders.
    const modules  = util.getModules();
    const isSuper  = localStorage.getItem('is_admin')        === '1'
                  || localStorage.getItem('is_national')     === '1'
                  || localStorage.getItem('is_client_admin') === '1';

    const tabItems = [
        { k:'Medical',     v:'Med Assets',     cat_type:'Med/NonMed', asset_cat_id:'3' },
        { k:'Non Medical', v:'Non Med Assets', cat_type:'Med/NonMed', asset_cat_id:'2' },
        { k:'Vehicle',     v:'Vehicle',        cat_type:'Med/NonMed', asset_cat_id:'8' },
       // { k:'Supplies',    v:'Supplies',       cat_type:'Med/NonMed', asset_cat_id:'9' },
    ];

    const filteredItems = isSuper ? tabItems : tabItems.filter(item => {
        if (item.k === 'Medical'     && modules.medical     === 1) return true;
        if (item.k === 'Non Medical' && modules.non_medical === 1) return true;
        if (item.k === 'Vehicle'     && modules.vehicle     === 1) return true;
        //if (item.k === 'Supplies'    && modules.supplies    === 1) return true;
        return false;
    });

    const [tab, setTab] = useState(filteredItems.length > 0 ? filteredItems[0].k : '');

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto"><PageHeading /></div>
                <div className="my-auto ml-auto"></div>
            </div>
            <div className="page-pad">
                <div className="tabbable-custom">
                    <BTabs active="items" />
                    <div className="tab-content">
                        <div className="tab-pane fade1 show active">
                            <Tabs
                                activeKey={tab}
                                destroyInactiveTabPane
                                onChange={onTabChange}
                                items={filteredItems.map(rw => ({
                                    key: rw.k,
                                    label: rw.v,
                                    children: (
                                        <List
                                            assetCats={assetCats}
                                            uoms={uoms}
                                            models={models}
                                            manufacturers={manufacturers}
                                            serviceProviders={serviceProviders}
                                            vendors={vendors}
                                            cat_type={rw.cat_type}
                                            asset_cat_id={rw.asset_cat_id}
                                            tabName={rw.k}
                                        />
                                    )
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

// ── List ──────────────────────────────────────────────────────────────────────
function List(props) {
    const { manufacturers, serviceProviders, vendors, tabName } = props;
    const [assetCats, setAssetCats] = useState([]);
    const [uoms,      setUoms]      = useState([]);
    const [models,    setModels]    = useState([]);
    const [subCats,   setSubCats]   = useState([]);
    const [result,    setResult]    = useState({ data: [], page: {} });
    const sdataRef  = useRef({ p: 1, ps: 25, cat_type: props.cat_type || '' });
    const formRef   = useRef();
    const importRef = useRef();
    sdataRef.current.asset_cat_id = props.asset_cat_id;

    const list = (p, ps) => {
        sdataRef.current.p  = p  || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        sdataRef.current.asset_cat_id = props.asset_cat_id;
        util.showLoader();
        AssetService.items(sdataRef.current).then(({ data }) => {
            setResult(data.result);
        }).catch(e => { message.error(e.message); }).finally(() => { util.hideLoader(); });
    };

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this item?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes', okType: 'danger', cancelText: 'No',
            onOk() {
                util.showLoader();
                AssetService.deleteItem(id).then(({ data }) => {
                    message.success(data.message || 'Deleted'); list();
                }).catch(e => { message.error(e.message); }).finally(() => { util.hideLoader(); });
            },
        });
    };

    const downloadTemplate = () => {
        const templateData = [
            ['Item Name', 'Sub Category', 'Model'],
            ['Toyota Hilux', 'Double Cab', 'Hilux 2.4'],
            ['Nissan Navara', 'Pick-Up', 'Navara'],
            ['X-Ray Machine', 'Radiology', ''],
            ['Blood Pressure Monitor', 'Cardiac Care', ''],
        ];
        const worksheet = XLSX.utils.aoa_to_sheet(templateData);
        const workbook  = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Items');
        worksheet['!cols'] = [{ width: 35 }, { width: 25 }, { width: 25 }];
        XLSX.writeFile(workbook, `${tabName.toLowerCase()}_items_template.xlsx`);
        message.success('Template downloaded');
    };

    const actionMenuItems = [
        { key:'add',      label:'Add Item',          icon:<img src={plus} alt='' height={15}/>, onClick:() => formRef.current.openForm() },
        { key:'import',   label:'Import from Excel', icon:<UploadOutlined />,                  onClick:() => importRef.current.openForm() },
        { key:'template', label:'Download Template', icon:<DownloadOutlined />,                onClick:downloadTemplate },
    ];

    useEffect(() => {
        const cats = props.assetCats.filter(v => v.id === props.asset_cat_id);
        setAssetCats(cats);
        if (props.asset_cat_id) {
            AssetService.allSubCats({ cat_id: props.asset_cat_id, status: 1 }).then(res => {
                setSubCats(res.data.result.data || []);
            }).catch(() => setSubCats([]));
        }
    }, [props.assetCats, props.cat_type, props.asset_cat_id]);

    useEffect(() => { setUoms(props.uoms); setModels(props.models); }, [props.uoms, props.models]);
    useEffect(() => { list(); return () => { message.destroy(); }; }, []);

    return (
        <div>
            <div>
                {result.data.length > 0 && (
                    <div className="text-secondary mb8">
                        Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                    </div>
                )}
                <div className="d-flex tbl-search-head">
                    <div className="my-auto">
                        <SearchForm dataRef={sdataRef} onSearch={list} />
                    </div>
                    <div className="ml-auto my-auto d-flex">
                        <Button type="primary" onClick={() => formRef.current.openForm()} style={{ marginRight: 8 }}>
                            <img src={plus} alt='' className='mr5' height={15}/> Add New Item
                        </Button>
                        <Dropdown menu={{ items: actionMenuItems }} trigger={['click']} placement="bottomRight">
                            <Button><MoreOutlined /></Button>
                        </Dropdown>
                    </div>
                </div>

                <If cond={result.data.length}>
                    <div className="table-responsive">
                        <table className="table table-bordered table-sm table-striped table-hover font-md m-0">
                            <thead className="thead-light text-uppercase table-text-vmid pad-y-md font-sm">
                                <tr>
                                    <th className="w20">SN</th>
                                    <th className="w150">Category</th>
                                    <th className="w150">Sub Category</th>
                                    <th>Item Name</th>
                                    {props.cat_type === 'Med/NonMed' && (
                                        <>
                                            <th className="w200"></th>
                                            <th className="w150">Model</th>
                                            <th className="w100">UoM</th>
                                        </>
                                    )}
                                    <th className="w60">Status</th>
                                    <th className="w70"></th>
                                </tr>
                            </thead>
                            <tbody className="table-text-top">
                                {result.data.map((v, i) => (
                                    <tr key={i}>
                                        <td>{result.page.start + i + 1}.</td>
                                        <td>{v.cat}</td>
                                        <td>{v.subcat || 'N/A'}</td>
                                        <td>
                                            {v.name}
                                            {props.cat_type === 'Med/NonMed' && (
                                                <div className="pt3 fs11 text-secondary">
                                                    Service Period: <span className="bold600">Every {v.service_period} {v.service_period_type}</span>
                                                </div>
                                            )}
                                        </td>
                                        {props.cat_type === 'Med/NonMed' && (
                                            <td>
                                                <div className='d-flex fs11' style={{ flexDirection:'column', gap:6 }}>
                                                    <div><div className='text-secondary'>Manufacturer:</div><div>{v.manufacturer || 'N/A'}</div></div>
                                                    <div><div className='text-secondary'>Service Provider:</div><div>{v.service_provider || 'N/A'}</div></div>
                                                    <div><div className='text-secondary'>Vendor:</div><div>{v.vendor || 'N/A'}</div></div>
                                                </div>
                                            </td>
                                        )}
                                        {props.cat_type === 'Med/NonMed' && (
                                            <>
                                                <td>{v.model}</td>
                                                <td>{v.uom}</td>
                                            </>
                                        )}
                                        <td className="nowrap">
                                            {v.status ? <AntdTag type="success">Active</AntdTag> : <AntdTag type="danger">Inactive</AntdTag>}
                                        </td>
                                        <td className="text-center">
                                            <Button.Group size="small">
                                                <Button type="default" onClick={() => formRef.current.openForm(v)}><img src={edit} alt='' height={15}/></Button>
                                                <Button type="default" onClick={() => deleteRecord(v.id)}><img src={xmark} alt='' height={15}/></Button>
                                            </Button.Group>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex tbl-foot-bx">
                        <AntdPaging
                            onChange={list}
                            total={result.page.total_records}
                            current={result.page.cur_page}
                            pageSize={sdataRef.current.ps}
                            showSizeChanger
                        />
                    </div>
                </If>
                <If cond={!result.data.length}>
                    <div className="no-rec">No record found</div>
                </If>
            </div>

            <AddForm
                ref={formRef}
                callback={list}
                pageno={sdataRef.current.p}
                assetCats={assetCats}
                manufacturers={manufacturers}
                serviceProviders={serviceProviders}
                vendors={vendors}
                uoms={uoms}
                models={models}
            />
            <ImportForm
                ref={importRef}
                callback={list}
                asset_cat_id={props.asset_cat_id}
                tabName={tabName}
                models={models}
                subCats={subCats}
            />
        </div>
    );
}

// ── ImportForm ────────────────────────────────────────────────────────────────
const ImportForm = forwardRef((props, ref) => {
    const { callback, asset_cat_id, tabName, models, subCats } = props;
    const [showForm,         setShowForm]       = useState(false);
    const [fileList,         setFileList]       = useState([]);
    const [previewData,      setPreviewData]    = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [importing,        setImporting]      = useState(false);
    const [importProgress,   setImportProgress] = useState(0);
    const [importSummary,    setImportSummary]  = useState(null);

    const resetForm = () => {
        setFileList([]); setPreviewData([]); setValidationErrors([]);
        setImportProgress(0); setImportSummary(null);
    };

    const handleFileUpload = (info) => {
        const { fileList: newList } = info;
        setFileList(newList.slice(-1));
        const file = newList[0]?.originFileObj;
        if (!file) return;
        const name = file.name.toLowerCase();
        if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
            message.error('Please upload only Excel files (.xlsx or .xls)');
            setFileList([]); return;
        }
        parseExcelFile(file);
    };

    const parseExcelFile = (file) => {
        util.showLoader();
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data     = new Uint8Array(e.target.result);
                const wb       = XLSX.read(data, { type: 'array' });
                const ws       = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(ws, { header:1, defval:'', blankrows:false });
                if (jsonData.length < 1) { message.error('Empty file'); return; }
                const firstRow = jsonData[0];
                const isHeader = firstRow.length > 0 && typeof firstRow[0] === 'string' &&
                    (firstRow[0].toLowerCase().includes('name') || firstRow[0].toLowerCase().includes('item'));
                const dataRows = isHeader ? jsonData.slice(1) : jsonData;
                if (dataRows.length === 0) { message.error('No data rows found'); return; }
                const { valid, errors } = processRows(dataRows);
                setPreviewData(valid); setValidationErrors(errors);
                if (valid.length > 0) message.success(`Found ${valid.length} valid item(s)`);
                else message.warning('No valid items found');
            } catch (err) { message.error('Failed to parse file: ' + err.message); }
            finally { util.hideLoader(); }
        };
        reader.readAsArrayBuffer(file);
    };

    const processRows = (rows) => {
        const valid = [], errors = [], seen = new Set();
        const modelList  = (models  || []).map(m => ({ id: m.id, name: m.name }));
        const subCatList = (subCats || []).map(s => ({ id: s.id, name: s.name }));
        rows.forEach((row, i) => {
            const rowNum    = i + 1;
            const itemName  = (row[0] || '').toString().trim();
            const subCatRaw = (row[1] || '').toString().trim();
            const modelRaw  = (row[2] || '').toString().trim();
            if (!itemName)          { errors.push(`Row ${rowNum}: Item name is required`); return; }
            if (itemName.length>100){ errors.push(`Row ${rowNum}: Name too long (max 100 chars)`); return; }
            const key = `${itemName.toLowerCase()}||${subCatRaw.toLowerCase()}||${modelRaw.toLowerCase()}`;
            if (seen.has(key)) { errors.push(`Row ${rowNum}: Duplicate — "${itemName}" skipped`); return; }
            seen.add(key);
            const subMatch = subCatRaw ? findBestMatch(subCatRaw, subCatList) : { id:null, name:null, score:0 };
            const modMatch = modelRaw  ? findBestMatch(modelRaw,  modelList)  : { id:null, name:null, score:0 };
            valid.push({
                name: itemName, asset_cat_id,
                asset_sub_cat_id: subMatch.score >= 0.65 ? subMatch.id : null,
                model_id:         modMatch.score >= 0.65 ? modMatch.id : null,
                uom_id: 1, status: 1, service_period_type: 'Months',
                _subCatRaw: subCatRaw, _subMatch: subMatch,
                _modelRaw:  modelRaw,  _modMatch:  modMatch,
            });
        });
        return { valid, errors };
    };

    const updateRow = (index, field, value) => {
        setPreviewData(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const performImport = async () => {
        if (previewData.length === 0) { message.error('No valid data to import'); return; }
        setImporting(true); setImportProgress(0); setImportSummary(null);
        let successCount = 0, skippedCount = 0;
        const errorMessages = [];
        for (let i = 0; i < previewData.length; i++) {
            const row = previewData[i];
            const payload = {
                name: row.name, asset_cat_id: row.asset_cat_id,
                asset_sub_cat_id: row.asset_sub_cat_id || null,
                model_id: row.model_id || null, uom_id: row.uom_id,
                status: row.status, service_period_type: row.service_period_type,
            };
            try { await AssetService.saveItem(payload); successCount++; }
            catch (e) {
                const msg = e.response?.data?.message || e.message || '';
                if (/duplicate|already exist/i.test(msg)) {
                    skippedCount++; errorMessages.push(`"${row.name}" already exists — skipped`);
                } else { errorMessages.push(`Row ${i+1} "${row.name}": ${msg}`); }
            }
            setImportProgress(Math.round(((i+1) / previewData.length) * 100));
        }
        setImportSummary({ successCount, skippedCount, errorMessages });
        setImporting(false);
        if (successCount > 0) { message.success(`${successCount} item(s) imported`); callback(1); }
        if (skippedCount > 0 && successCount === 0) message.warning('All rows skipped — likely duplicates');
    };

    const closeForm = () => { setShowForm(false); resetForm(); };
    useImperativeHandle(ref, () => ({ openForm() { resetForm(); setShowForm(true); } }));

    const modelList  = (models  || []).map(m => ({ id: m.id, name: m.name }));
    const subCatList = (subCats || []).map(s => ({ id: s.id, name: s.name }));

    const columns = [
        { title:'#', key:'n', width:40, render:(_,__,i) => <span style={{color:'#999',fontSize:11}}>{i+1}</span> },
        { title:'Item Name', dataIndex:'name', key:'name', width:220, render:v => <span style={{fontWeight:500}}>{v}</span> },
        {
            title: <Tooltip title="Col B: matched against sub categories"><span>Sub Category <QuestionCircleOutlined style={{color:'#aaa',marginLeft:4}}/></span></Tooltip>,
            key:'subcat', width:260,
            render: (_,record,i) => (
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <Select showSearch allowClear size="small" style={{flex:1,minWidth:140}}
                        placeholder={record._subCatRaw||'None'} value={record.asset_sub_cat_id||undefined}
                        onChange={v => updateRow(i,'asset_sub_cat_id',v||null)}
                        filterOption={(input,option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                        {subCatList.map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                    </Select>
                    {record._subCatRaw && <Tooltip title={record._subMatch.score>=0.65 ? `Matched "${record._subMatch.name}"` : `No confident match — select manually`}><ConfidenceBadge score={record._subMatch.score}/></Tooltip>}
                </div>
            ),
        },
        {
            title: <Tooltip title="Col C: matched against models"><span>Model <QuestionCircleOutlined style={{color:'#aaa',marginLeft:4}}/></span></Tooltip>,
            key:'model', width:260,
            render: (_,record,i) => (
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <Select showSearch allowClear size="small" style={{flex:1,minWidth:140}}
                        placeholder={record._modelRaw||'None'} value={record.model_id||undefined}
                        onChange={v => updateRow(i,'model_id',v||null)}
                        filterOption={(input,option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                        {modelList.map(m => <Option key={m.id} value={m.id}>{m.name}</Option>)}
                    </Select>
                    {record._modelRaw && <Tooltip title={record._modMatch.score>=0.65 ? `Matched "${record._modMatch.name}"` : `No confident match — select manually`}><ConfidenceBadge score={record._modMatch.score}/></Tooltip>}
                </div>
            ),
        },
    ];

    const lowConfidenceCount = previewData.filter(r =>
        (r._subCatRaw && r._subMatch.score > 0 && r._subMatch.score < 0.65) ||
        (r._modelRaw  && r._modMatch.score  > 0 && r._modMatch.score  < 0.65)
    ).length;
    const unmatchedCount = previewData.filter(r =>
        (r._subCatRaw && !r.asset_sub_cat_id) || (r._modelRaw && !r.model_id)
    ).length;

    return (
        <Modal title={`Import ${tabName} Items from Excel`} open={showForm} onCancel={closeForm} width={960}
            footer={[
                <Button key="cancel" onClick={closeForm} disabled={importing}>Cancel</Button>,
                <Button key="import" type="primary" onClick={performImport}
                    disabled={previewData.length===0||importing||!!importSummary} loading={importing}>
                    {importing ? `Importing… ${importProgress}%` : `Import ${previewData.length} Items`}
                </Button>
            ]}>
            {!importSummary && (
                <>
                    <div style={{marginBottom:16}}>
                        <Dragger fileList={fileList} onChange={handleFileUpload} beforeUpload={()=>false}
                            accept=".xlsx,.xls" maxCount={1} disabled={importing}>
                            <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                            <p className="ant-upload-text">Click or drag Excel file to upload</p>
                            <p className="ant-upload-hint">3 columns: <strong>Item Name</strong> · <strong>Sub Category</strong> · <strong>Model</strong> — Sub Category and Model are optional</p>
                        </Dragger>
                    </div>
                    {importing && <Progress percent={importProgress} status="active" style={{marginBottom:16}}/>}
                    {validationErrors.length > 0 && (
                        <Alert message={`${validationErrors.length} row(s) skipped during parsing`}
                            description={<div style={{maxHeight:100,overflowY:'auto'}}><ul style={{margin:0,paddingLeft:20}}>{validationErrors.slice(0,8).map((e,i)=><li key={i}>{e}</li>)}{validationErrors.length>8&&<li>…and {validationErrors.length-8} more</li>}</ul></div>}
                            type="warning" showIcon style={{marginBottom:12}}/>
                    )}
                    {previewData.length > 0 && unmatchedCount > 0 && (
                        <Alert message={`${unmatchedCount} row(s) have unmatched Sub Category or Model`}
                            description="Use the dropdowns to assign manually, or leave blank."
                            type="warning" showIcon style={{marginBottom:12}}/>
                    )}
                    {previewData.length > 0 && (
                        <>
                            <Divider style={{margin:'12px 0'}}>
                                Preview — {previewData.length} item(s)
                                {lowConfidenceCount > 0 && <span style={{color:'#fa8c16',fontSize:12,marginLeft:8}}>· {lowConfidenceCount} need manual review</span>}
                            </Divider>
                            <div style={{display:'flex',gap:16,marginBottom:8,fontSize:12,color:'#666'}}>
                                <span><Tag color="success" style={{fontSize:11}}>90%+</Tag> High confidence</span>
                                <span><Tag color="warning" style={{fontSize:11}}>65–89%</Tag> Review suggested</span>
                                <span><Tag color="error"   style={{fontSize:11}}>&lt;65%</Tag> Select manually</span>
                                <span><Tag color="default" style={{fontSize:11}}>No match</Tag> No value in Excel</span>
                            </div>
                            <Table columns={columns} dataSource={previewData} rowKey={(_,i)=>i}
                                size="small" pagination={{pageSize:10,showTotal:t=>`${t} items`}}
                                scroll={{x:780,y:320}}
                                rowClassName={record=>((record._subCatRaw&&!record.asset_sub_cat_id)||(record._modelRaw&&!record.model_id))?'row-needs-review':''}/>
                            <style>{`.row-needs-review td { background: #fff7e6 !important; }`}</style>
                        </>
                    )}
                    <Alert message="Excel Format"
                        description={<div><p style={{margin:'4px 0'}}><strong>Column A</strong> — Item Name (required) &nbsp;<strong>Column B</strong> — Sub Category (optional) &nbsp;<strong>Column C</strong> — Model (optional)</p></div>}
                        type="info" showIcon style={{marginTop:12}}/>
                </>
            )}
            {importSummary && (
                <Alert message="Import Complete"
                    description={<div><p><strong>Imported:</strong> {importSummary.successCount}</p>{importSummary.skippedCount>0&&<p><strong>Skipped:</strong> {importSummary.skippedCount}</p>}{importSummary.errorMessages.length>0&&<div style={{maxHeight:120,overflowY:'auto',marginTop:8}}><ul style={{margin:0,paddingLeft:20,color:'#cf1322',fontSize:12}}>{importSummary.errorMessages.map((m,i)=><li key={i}>{m}</li>)}</ul></div>}</div>}
                    type={importSummary.successCount>0?'success':'warning'} showIcon/>
            )}
        </Modal>
    );
});

// ── SearchForm ────────────────────────────────────────────────────────────────
const SearchForm = (props) => {
    let { dataRef, onSearch } = props;
    let [data, setData] = useState({ ...dataRef.current });
    const handleChange = (v, k) => { data[k] = v; setData({ ...data }); };
    useEffect(() => { dataRef.current = { ...data }; }, [data]);
    useEffect(() => { setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps }); }, [dataRef.current.p, dataRef.current.ps]);
    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div><Input placeholder="Search" allowClear value={data.k} onChange={e => handleChange(e.target.value, 'k')} /></div>
                <div><Button type="primary" icon={<img src={search} alt='' className='mr5' height={15}/>} onClick={() => onSearch()}></Button></div>
            </div>
        </form>
    );
};

// ── AddForm ───────────────────────────────────────────────────────────────────
const AddForm = forwardRef((props, ref) => {
    let { callback, pageno, assetCats, manufacturers, serviceProviders, vendors, uoms, models } = props;
    const [showForm, setShowForm] = useState(false);
    let [data, setData]     = useState({});
    let [catDtl, setCatDtl] = useState({ subcats: [] });
    let [render, reRender]  = useState(false);

    const handleChange = (v, k) => {
        data[k] = v;
        if (k === 'asset_cat_id') { data.asset_sub_cat_id = null; setCatDtl(getCatDtl(v)); }
        setData({ ...data });
    };

    const getCatDtl = (cat_id) => {
        let dtl = { subcats: [] };
        assetCats.forEach(r => { if (r.id === cat_id) dtl = util.copyObj(r); });
        return dtl;
    };

    const save = () => {
        message.destroy(); util.showLoader();
        const mylifespan = `${data.lifespanValue} ,  ${data.lifespanUnit}`;
        AssetService.saveItem({ ...data, lifespan: mylifespan }).then(({ data }) => {
            message.success(data.message || 'Saved');
            callback(data.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => { message.error(e.message); }).finally(() => { util.hideLoader(); });
    };

    useEffect(() => { reRender(!render); }, [assetCats]);

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            let asset_cat_id = null;
            if (!dtl) { asset_cat_id = assetCats[0]?.id; setCatDtl(getCatDtl(asset_cat_id)); }
            if (dtl)  { setCatDtl(getCatDtl(dtl.asset_cat_id)); }
            setData(dtl ? { ...dtl } : { asset_cat_id, service_period_type: 'Months', status: '1' });
            setShowForm(true);
        }
    }));

    return (
        <Modal title={`${data.id ? 'Edit' : 'Add'} Item`} open={showForm} okText="Save"
            onOk={save} onCancel={() => setShowForm(false)} destroyOnClose maskClosable={false} width={400} style={{ top:20 }}>
            <form onSubmit={e => { e.preventDefault(); save(); }} autoComplete="off" spellCheck="false">
                <div className="row mingap">
                    <div className="col-md-12 form-group">
                        <label className="req">Category</label>
                        <div><AntdSelect showSearch options={assetCats} value={data.asset_cat_id} onChange={v => handleChange(v,'asset_cat_id')} /></div>
                    </div>
                    {catDtl.subcats?.length > 0 && (
                        <div className="col-md-12 form-group">
                            <label className="req">Sub Category</label>
                            <div><AntdSelect sort showSearch options={catDtl.subcats} value={data.asset_sub_cat_id} onChange={v => handleChange(v,'asset_sub_cat_id')} /></div>
                        </div>
                    )}
                    <div className="col-md-12 form-group">
                        <label className="req">Item Name / Make</label>
                        <Input value={data.name||''} onChange={e => handleChange(e.target.value,'name')} />
                    </div>
                    <div className="col-md-12 form-group">
                        <label>Model</label>
                        <div><AntdSelect sort options={models} showSearch allowClear value={data.model_id} onChange={v => handleChange(v,'model_id')} /></div>
                    </div>
                    <div className="col-md-6 form-group">
                        <label className="req">UoM</label>
                        <div><AntdSelect showSearch options={uoms} value={data.uom_id} onChange={v => handleChange(v,'uom_id')} /></div>
                    </div>
                    <div className="col-md-6 form-group">
                        <label className="req">Status</label>
                        <div><AntdSelect options={[{value:'1',label:'Active'},{value:'0',label:'Inactive'}]} value={data.status} onChange={v => handleChange(v,'status')} /></div>
                    </div>
                </div>
            </form>
        </Modal>
    );
});